import {
  Action,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from 'corso-admin-ui';
import { PropsWithChildren } from 'react';

export default function InfoPopover({
  title,
  children,
}: PropsWithChildren<{
  title: string;
}>) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Action icon="info" accessibilityLabel={title} variant="ghost" />
      </PopoverTrigger>
      <PopoverContent align="start">{children}</PopoverContent>
    </Popover>
  );
}

function InfoPopoverProse({ children }: { children: string }) {
  return <p className="max-w-prose text-xs text-neutral-800">{children}</p>;
}

InfoPopover.Prose = InfoPopoverProse;
